enum TenantId {
  GEOLLECT = 'GEOLLECT',
}

export default TenantId;
